export default __webpack_public_path__ + "static/media/real_estate_web-xs@1x.62db0fea.jpg";